import { Box, Button, Icon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext, useEffect, useRef } from 'react';
import { PollContext } from '../../shared/context/PollContext';
import PollModal from './interact/PollModal';

const useStyles = makeStyles((theme) => ({
  pollBg: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 5,
  },
  pollIcon: {
    verticalAlign: 'bottom',
    color: theme.palette.primary.main,
  },
}));

const PollList = () => {
  const classes = useStyles();
  const modalRef = useRef();
  const { pollState } = useContext(PollContext);

  const openPoll = (poll) => {
    modalRef.current.setState({ open: true, poll: poll });
  };

  useEffect(() => {
    if (pollState.poll && pollState.poll.pollAnswers.length === 0) {
      modalRef.current.setState({ open: true, poll: pollState.poll });
    }
    if (!pollState.poll) {
      modalRef.current.setState({ open: false, poll: null });
    }
  }, [pollState.poll && pollState.poll.id]);

  return (
    <Box position="relative" className={classes.pollBg}>
      <PollModal ref={modalRef} />
      {pollState.poll && pollState.poll.pollAnswers.length === 0 && (
        <Box p={1} display="flex" alignItems="center" justifyContent="center">
          <Box>
            <Button
              onClick={() => openPoll(pollState.poll)}
              startIcon={<Icon>poll</Icon>}
              size="small"
              variant="contained"
              color="primary"
            >
              Open poll
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PollList;
